import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  lastNotification: null,
  language: localStorage.getItem("nexora-lang") || "fr",
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setLastNotification(state, action) {
      state.lastNotification = action.payload || null;
    },
    setLanguage(state, action) {
      state.language = action.payload || "fr";
      localStorage.setItem("nexora-lang", state.language);
    },
  },
});

export const { setLastNotification, setLanguage } = appSlice.actions;
export default appSlice.reducer;
